import * as React from "react";
import type { SVGProps } from "react";
const SvgIconAlertTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 20"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.68 0c-.73.05-1.42.42-1.83 1-.12.17-8.47 14.48-8.6 14.73-.75 1.5.27 3.33 1.96 3.5.34.04 16.9.04 17.23 0 .84-.08 1.56-.58 1.95-1.34.34-.68.34-1.5 0-2.16-.11-.25-8.47-14.56-8.58-14.72-.36-.5-.96-.88-1.55-.97-.19-.03-.43-.05-.58-.04m-.12 1.76q-.13.04-.24.16c-.08.09-1.28 2.13-4.29 7.28L1.8 16.5q-.15.3 0 .61c.05.08.13.2.19.25.2.19-.65.17 8.85.17s8.64.02 8.84-.17c.26-.24.33-.59.2-.86l-4.25-7.3c-3.4-5.83-4.2-7.18-4.3-7.29q-.31-.3-.76-.15m.03 3.86c-.31.1-.55.37-.6.68-.04.18-.04 5.3 0 5.48.03.2.1.31.25.46.3.29.77.32 1.1.06.13-.1.26-.27.3-.4.04-.12.06-5.33.03-5.57q-.09-.44-.47-.65c-.1-.05-.16-.06-.34-.07zm-.05 7.96c-.42.1-.82.48-.93.9-.04.17-.04.48 0 .66.1.38.4.7.8.86.12.04.18.05.42.05s.3 0 .42-.05q.3-.12.5-.36c.23-.25.32-.5.32-.83 0-.37-.1-.64-.37-.9q-.48-.46-1.16-.33"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconAlertTriangle;
